import { plugin as networkBreadcrumbsPlugin } from "@appsignal/plugin-breadcrumbs-network"
import { plugin as pathDecoratorPlugin } from "@appsignal/plugin-path-decorator"
import { installErrorHandler } from "@appsignal/stimulus"
import { Application } from "@hotwired/stimulus"
import appsignal from "../lib/appsignal"

const application = Application.start()

application.debug = false
window.Stimulus = application

if (appsignal) {
  ;[networkBreadcrumbsPlugin, pathDecoratorPlugin].forEach(plugin => {
    appsignal.use(plugin())
  })
  installErrorHandler(appsignal, application)
}

export { application }
